// src/theme.ts
import { createTheme } from "@mui/material/styles";
import { IS_DEVELOPMENT } from "./config";

export const theme = createTheme({
  palette: {
    mode: "light",

    // Brand & Primary
    primary: {
      light: "#69B1F1", // primary.400
      main: "#4593EC", // primary.500
      dark: "#3076E0", // primary.600
      contrastText: "#FFFFFF",
    },

    secondary: {
      light: "#93C5FD", // secondary.300
      main: "#3B81F6", // secondary.500
      dark: "#2761CE", // primary.700
      contrastText: "#FFFFFF",
    },

    success: {
      light: "#9DE0D3", // success.50
      main: "#40C4AA", // success.100
      dark: "#287F6E", // success.200
      contrastText: "#FFFFFF",
    },

    warning: {
      light: "#FBD982", // warning.50
      main: "#FFBD4C", // warning.100
      dark: "#956321", // warning.200
      contrastText: "#141414",
    },

    error: {
      light: "#FADAE1", // error.25
      main: "#DF1C41", // error.100
      dark: "#95122B", // error.200
      contrastText: "#FFFFFF",
    },

    background: {
      default: "#F6F8FA", // grey.25
      paper: "#FFFFFF", // grey.0
    },

    text: {
      primary: "#353849", // grey.600
      secondary: "#808897", // grey.400
    },

    divider: "#DFE1E6", // grey.100
  },

  typography: {
    fontFamily:
      "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",

    h1: { fontSize: 32, fontWeight: 700, lineHeight: "40px" },
    h2: { fontSize: 28, fontWeight: 700, lineHeight: "36px" },
    h3: { fontSize: 24, fontWeight: 700, lineHeight: "32px" },

    subtitle1: { fontSize: 18, fontWeight: 700, lineHeight: "26px" }, // titleLg
    subtitle2: { fontSize: 16, fontWeight: 700, lineHeight: "24px" }, // title

    body1: { fontSize: 16, fontWeight: 400, lineHeight: "24px" },
    body2: { fontSize: 14, fontWeight: 400, lineHeight: "20px" },

    button: { fontSize: 14, fontWeight: 700, lineHeight: "20px" },
    caption: { fontSize: 12, fontWeight: 400, lineHeight: "16px" },
  },

  shape: {
    borderRadius: 8,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          // Use orange/amber color for development, teal for production
          backgroundColor: IS_DEVELOPMENT ? "#FF6B35" : "#004D4E", // Orange for dev, teal for prod
          color: "#F6F6F2", // brand.offWhite
        },
      },
    },
  },
});
